window.breeze = {
  sendProductNameInNotes: async (productNames) => {
    const bundle = "bundle";
    const strings = productNames; // Assuming productNames is the array of strings you want to filter
    const filteredStrings = [];
    const lowerCaseBundle = bundle.toLowerCase();
    for (const str of strings) {
        const lowerCaseStr = str.toLowerCase();
        if (lowerCaseStr.includes(lowerCaseBundle)) {
            filteredStrings.push(str);
        }
    }
    if(filteredStrings.length > 0) {
      return filteredStrings;
    } else {
      return null;
    }
  }
};
